import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnKR: CultureInfo = {
  name: 'en-KR',
  displayName: 'English (South Korea)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-KR',
  parent: CultureInfoEn
};
